import { format } from '@/components/widgets/PrMoneyUtilFormat';

// Filtro para converter um objeto float
// no formato da moeda Real
export default (value, opts = {}) => {
  const defaults = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
  };

  const params = { ...defaults, ...opts };

  return format(value, params);
};




// WEBPACK FOOTER //
// ./src/filters/CurrencyFilter.js